import { render, staticRenderFns } from "./PartnersSideviewGeneralTab.vue?vue&type=template&id=39ca026d&scoped=true&class=fill-height&"
import script from "./PartnersSideviewGeneralTab.vue?vue&type=script&lang=ts&"
export * from "./PartnersSideviewGeneralTab.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersSideviewGeneralTab.vue?vue&type=style&index=0&id=39ca026d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca026d",
  null
  
)

export default component.exports